import { mutationOptions } from '@tanstack/react-query'
import { keys } from '../queries/keys'
import {
  declarePlatformStock,
  deletePlatformStock,
  deletePlatformStockLog,
  exportPlatformStocks,
  importPlatformStocks,
  revertPlatformStockLog,
} from './platform-stocks.mutations'

export const declarePlatformStockOptions = () =>
  mutationOptions({
    mutationFn: declarePlatformStock,
    onSuccess: (_data, _variables, _onResult, context) => {
      void context.client.invalidateQueries({ queryKey: keys.platformStocks.all })
    },
  })

export const deletePlatformStockOptions = () =>
  mutationOptions({
    mutationFn: deletePlatformStock,
    onSuccess: (_data, _variables, _onResult, context) => {
      void context.client.invalidateQueries({ queryKey: keys.platformStocks.all })
    },
  })

export const deletePlatformStockLogOptions = (stockId: number) =>
  mutationOptions({
    mutationFn: deletePlatformStockLog,
    onSuccess: (_data, _variables, _onResult, context) => {
      void context.client.invalidateQueries({ queryKey: keys.platformStocks.logs(stockId) })
      void context.client.invalidateQueries({ queryKey: keys.platformStocks.lists() })
    },
  })

export const revertPlatformStockLogOptions = (stockId: number) =>
  mutationOptions({
    mutationFn: revertPlatformStockLog,
    onSuccess: (_data, _variables, _onResult, context) => {
      void context.client.invalidateQueries({ queryKey: keys.platformStocks.logs(stockId) })
      void context.client.invalidateQueries({ queryKey: keys.platformStocks.lists() })
    },
  })

export const exportPlatformStocksOptions = (params?: {
  storeReference?: string
  internalCategoryIds?: number[]
}) =>
  mutationOptions({
    mutationFn: () => exportPlatformStocks(params),
  })

export const importPlatformStocksOptions = () =>
  mutationOptions({
    mutationFn: importPlatformStocks,
    onSuccess: (_data, _variables, _onResult, context) => {
      void context.client.invalidateQueries({ queryKey: keys.platformStocks.all })
    },
  })
